// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oW8T","content":"styles_content__3Dqom"};